/* PillePárna – Releasit magyar hibaüzenetek */
(() => {
  const translations = [
    ['Please check the form for errors', 'Kérjük, ellenőrizd a megadott adatokat.'],
    ['Remove discount ', 'Kupon eltávolítása: '],
    ['Discount not applicable', 'A kuponkód ehhez a rendeléshez nem használható.'],
    ['Only one discount code allowed', 'Rendelésenként csak egy kuponkód használható.'],
    ['Discount already applied', 'Ez a kuponkód már alkalmazva van.'],
    ['Discount code already applied', 'Ez a kuponkód már alkalmazva van.'],
    ['Discount is already applied', 'Ez a kuponkód már alkalmazva van.'],
    ['Failed to create order', 'A rendelést nem sikerült leadni. Kérjük, próbáld újra.']
  ];

  const replaceKnownText = (value) => {
    if (!value) return value;
    let output = value;

    for (const [en, hu] of translations) {
      output = output.replaceAll(en, hu);
    }

    return output;
  };

  const translateTextNode = (node) => {
    if (!node || node.nodeType !== Node.TEXT_NODE || !node.nodeValue) return;
    const translated = replaceKnownText(node.nodeValue);
    if (translated !== node.nodeValue) node.nodeValue = translated;
  };

  const translateTree = (root) => {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      translateTextNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root !== document.body) return;

    const elements = [root, ...root.querySelectorAll('[aria-label], [title]')];
    elements.forEach((element) => {
      for (const attribute of ['aria-label', 'title']) {
        const value = element.getAttribute?.(attribute);
        const translated = replaceKnownText(value);
        if (value && translated !== value) element.setAttribute(attribute, translated);
      }
    });

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let current;
    while ((current = walker.nextNode())) {
      translateTextNode(current);
    }
  };

  const start = () => {
    translateTree(document.body);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'characterData') {
          translateTextNode(mutation.target);
          continue;
        }

        mutation.addedNodes.forEach((node) => translateTree(node));
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    // Biztonsági újraellenőrzés a Releasit dinamikusan betöltődő üzeneteihez.
    setInterval(() => translateTree(document.body), 1200);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
